export const steps = {
    common: ['details'],
    cottage: ['details', 'address', 'amenities', 'rates', 'additional', 'gallery', 'reviews', 'custom'],
    inn: ['details', 'address', 'roomtypes'],
    roomtype: ['details', 'rooms', 'amenities', 'rates', 'additional', 'gallery', 'reviews', 'custom', 'parent'],
};

export const distanceUnitChoice = [
    { value: 'MILES', text: 'Miles' },
    { value: 'KILOMETRES', text: 'Kilometres' },
    { value: 'METRES', text: 'Metres' },
    { value: 'MINUTES', text: 'Minutes' },
];

export const cicoChoices = [
    { value: '00:00:00', text: '12:00 AM' },
    { value: '00:30:00', text: '12:30 AM' },
    { value: '01:00:00', text: '01:00 AM' },
    { value: '01:30:00', text: '01:30 AM' },
    { value: '02:00:00', text: '02:00 AM' },
    { value: '02:30:00', text: '02:30 AM' },
    { value: '03:00:00', text: '03:00 AM' },
    { value: '03:30:00', text: '03:30 AM' },
    { value: '04:00:00', text: '04:00 AM' },
    { value: '04:30:00', text: '04:30 AM' },
    { value: '05:00:00', text: '05:00 AM' },
    { value: '05:30:00', text: '05:30 AM' },
    { value: '06:00:00', text: '06:00 AM' },
    { value: '06:30:00', text: '06:30 AM' },
    { value: '07:00:00', text: '07:00 AM' },
    { value: '07:30:00', text: '07:30 AM' },
    { value: '08:00:00', text: '08:00 AM' },
    { value: '08:30:00', text: '08:30 AM' },
    { value: '09:00:00', text: '09:00 AM' },
    { value: '09:30:00', text: '09:30 AM' },
    { value: '10:00:00', text: '10:00 AM' },
    { value: '10:30:00', text: '10:30 AM' },
    { value: '11:00:00', text: '11:00 AM' },
    { value: '11:30:00', text: '11:30 AM' },
    { value: '12:00:00', text: '12:00 PM' },
    { value: '12:30:00', text: '12:30 PM' },
    { value: '13:00:00', text: '01:00 PM' },
    { value: '13:30:00', text: '01:30 PM' },
    { value: '14:00:00', text: '02:00 PM' },
    { value: '14:30:00', text: '02:30 PM' },
    { value: '15:00:00', text: '03:00 PM' },
    { value: '15:30:00', text: '03:30 PM' },
    { value: '16:00:00', text: '04:00 PM' },
    { value: '16:30:00', text: '04:30 PM' },
    { value: '17:00:00', text: '05:00 PM' },
    { value: '17:30:00', text: '05:30 PM' },
    { value: '18:00:00', text: '06:00 PM' },
    { value: '18:30:00', text: '06:30 PM' },
    { value: '19:00:00', text: '07:00 PM' },
    { value: '19:30:00', text: '07:30 PM' },
    { value: '20:00:00', text: '08:00 PM' },
    { value: '20:30:00', text: '08:30 PM' },
    { value: '21:00:00', text: '09:00 PM' },
    { value: '21:30:00', text: '09:30 PM' },
    { value: '22:00:00', text: '10:00 PM' },
    { value: '22:30:00', text: '10:30 PM' },
    { value: '23:00:00', text: '11:00 PM' },
    { value: '23:30:00', text: '11:30 PM' },
];

export const bedroomsChoices = [
    { value: '-1', text: 'N/A' },
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' },
    { value: '13', text: '13' },
    { value: '14', text: '14' },
    { value: '15', text: '15' },
    { value: '16', text: '16' },
    { value: '17', text: '17' },
    { value: '18', text: '18' },
    { value: '19', text: '19' },
    { value: '20', text: '20' },
    { value: '21', text: '21' },
    { value: '22', text: '22' },
    { value: '23', text: '23' },
    { value: '24', text: '24' },
    { value: '25', text: '25' },
];

export const bathsChoices = [
    { value: '0.0', text: 'N/A' },
    { value: '1.0', text: '1.0' },
    { value: '1.5', text: '1.5' },
    { value: '2.0', text: '2.0' },
    { value: '2.5', text: '2.5' },
    { value: '3.0', text: '3.0' },
    { value: '3.5', text: '3.5' },
    { value: '4.0', text: '4.0' },
    { value: '4.5', text: '4.5' },
    { value: '5.0', text: '5.0' },
    { value: '5.5', text: '5.5' },
    { value: '6.0', text: '6.0' },
    { value: '6.5', text: '6.5' },
    { value: '7.0', text: '7.0' },
    { value: '7.5', text: '7.5' },
    { value: '8.0', text: '8.0' },
    { value: '8.5', text: '8.5' },
    { value: '9.0', text: '9.0' },
    { value: '9.5', text: '9.5' },
    { value: '10.0', text: '10.0' },
    { value: '10.5', text: '10.5' },
    { value: '11.0', text: '11.0' },
    { value: '11.5', text: '11.5' },
    { value: '12.0', text: '12.0' },
    { value: '12.5', text: '12.5' },
    { value: '13.0', text: '13.0' },
    { value: '13.5', text: '13.5' },
    { value: '14.0', text: '14.0' },
    { value: '14.5', text: '14.5' },
    { value: '15.0', text: '15.0' },
    { value: '15.5', text: '15.5' },
    { value: '16.0', text: '16.0' },
    { value: '16.5', text: '16.5' },
    { value: '17.0', text: '17.0' },
    { value: '17.5', text: '17.5' },
    { value: '18.0', text: '18.0' },
    { value: '18.5', text: '18.5' },
    { value: '19.0', text: '19.0' },
    { value: '19.5', text: '19.5' },
    { value: '20.0', text: '20.0' },
    { value: '20.5', text: '20.5' },
    { value: '21.0', text: '21.0' },
    { value: '21.5', text: '21.5' },
    { value: '22.0', text: '22.0' },
    { value: '22.5', text: '22.5' },
    { value: '23.0', text: '23.0' },
    { value: '23.5', text: '23.5' },
    { value: '24.0', text: '24.0' },
    { value: '24.5', text: '24.5' },
];

export const newRateObject = {
    id: 0,
    name: 'New Rate',
    period: { from_date: null, to_date: null },
    min_nights: 1,
    daily_rate: '',
    weekend_rate: '',
    weekend_rate_enabled: false,
    weekly_rate: '',
    monthly_rate: '',
    arrival_day: 5,
    departure_day: 5,
    extra_person_base: 1,
    extra_person_rate: '',
    default: false,
};

export const newReviewObject = {
    id: 0,
    name: '',
    date: '',
    title: 'New Review',
    description: '',
    language: 'en',
    stars: 5,
    rental_property: null,
};

export const howBigUnitOptions = [
    {
        value: 'METERS_SQUARED',
        text: 'Meters Squared',
    },
    {
        value: 'SQUARE_FEET',
        text: 'Square Feet',
    },
];

export const bookingWidgetOptions = [
    {
        text: 'Accept online bookings',
        value: 0,
    },
    {
        text: 'Availability Only - NO Online Bookings',
        value: 1,
    },
    {
        text: 'No Availability Display / No Online Bookings',
        value: 2,
    },
];
